/*
 *   Copyright (c) 2026 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const HOLD_TICKETS = gql`
  mutation HoldTickets($data: HoldTicketsInput!) {
    holdTickets(data: $data) {
      ticketOrderId
      boxId
      feteId
      feteName
      status
      ticketAmount
      convenienceFee
      total
      currency
      holdExpiresAt
      lines {
        tierId
        tierName
        quantity
        unitPrice
        originalUnitPrice
        discountPct
        lineTotal
        feePerTicket
        lineFee
      }
    }
  }
`;
